import Vue from "vue"
import { computed } from "@vue/composition-api"
import axios from "axios"

interface LocaleState {
  locale: string
}

export const LOCALE_KEY = "locale"

export const localeState = Vue.observable<LocaleState>({
  locale: "de", // default
})

export const locale = computed(() => {
  return localeState.locale
})

export function setLanguage(locale: string) {
  localeState.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)

  // Set Header for all requests
  axios.defaults.headers.common["App-Locale"] = locale
}

export function getLanguage(supportedLanguages: string[]): string {
  let locale = localStorage.getItem(LOCALE_KEY)

  // if (!locale) {
  locale = navigator.language.split("-")[0]
  if (locale && !supportedLanguages.includes(locale)) {
    locale = "de"
  }
  setLanguage(locale)
  // }

  // Set Header for all requests
  axios.defaults.headers.common["App-Locale"] = locale

  return locale
}
